import { render, staticRenderFns } from "./FormDisabledPerson.vue?vue&type=template&id=ae8e0c90&scoped=true&"
import script from "./FormDisabledPerson.vue?vue&type=script&lang=js&"
export * from "./FormDisabledPerson.vue?vue&type=script&lang=js&"
import style0 from "./FormDisabledPerson.vue?vue&type=style&index=0&id=ae8e0c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8e0c90",
  null
  
)

export default component.exports